import angular from 'angular';
import { compact } from 'lodash';

module.exports = angular.module('common.filters.address', [])
.filter('address', function() {
  return function(address, joiner = ', ') {
    if (!address) return "";

    return compact([
      address.street1,
      address.street2,
      address.city,
      address.state,
      address.postal_code,
    ]).join(joiner);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/address.js
 **/